const Hospedagem = () => {
  return window.location.replace(
    'https://sigevent.pro/merkator/hospedagem/solicitacaowebempresa/index.php?id_edicao=304&linguagem=portugues'
  );
};

export default Hospedagem;
